import "./EditNotificationSubscriptions.html";
import "./EditNotificationSubscriptions.scss";

import "../FindAddUser/FindAddUserComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditNotificationSubscriptionsComponentController from "./EditNotificationSubscriptionsComponentController";

export default class EditNotificationSubscriptionsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            configurationGroup: "=",
            site: "<",
            subscribersAssigned: "=",
            subscriptions: "=",
            types: "<",
        };
        this.controller = EditNotificationSubscriptionsComponentController;
        this.templateUrl = "/App/Components/Forms/EditNotificationSubscriptions/EditNotificationSubscriptions.html";
    }
}

module("mmManagePortal").component("irEditNotificationSubscriptions", new EditNotificationSubscriptionsComponent());
